import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Upload = (props) => (
  <Icon viewBox="0 0 15 15" {...props}>
    <g>
      <g fill="currentColor" fillRule="evenodd">
        <path d="M14 8.037v3.5c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5v-3.5H0v3.5c0 1.378 1.122 2.5 2.5 2.5h10c1.378 0 2.5-1.122 2.5-2.5v-3.5h-1z" />
        <path d="M7 1.623v9.414h1V1.623l2.718 2.698.564-.568L7.5 0 3.718 3.753l.564.568z" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Upload;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Upload.js